export default __webpack_public_path__ + "static/Entenda0120-c4a4b71288c6fb00c9360e10f4dba818.jpg";